import React from 'react'

import Button from 'components/Button'
import ErrorMessage from 'components/ErrorMessage'

import { IndexLayoutHeader, IndexLayoutHeaderProps } from './IndexLayoutHeader'
import { Wrapper } from './IndexLayout.styles'
import Sidebar, { Variant } from './Sidebar'

interface IndexLayoutErrorProps extends IndexLayoutHeaderProps {
  variant?: Variant
}

export const IndexLayoutError: React.FC<IndexLayoutErrorProps> = ({
  headerLink,
  variant,
}) => (
  <Wrapper>
    <IndexLayoutHeader headerLink={headerLink} blockLogoLink />
    {variant && <Sidebar variant={variant} />}
    <ErrorMessage.Generic
      title="There was an error loading this page"
      extra={
        <Button variant="primary" onClick={() => window.location.reload()}>
          Refresh the page to try again
        </Button>
      }
    />
  </Wrapper>
)
